import { render, staticRenderFns } from "./message-status-icon.vue?vue&type=template&id=97210bde&scoped=true"
import script from "./message-status-icon.vue?vue&type=script&lang=js"
export * from "./message-status-icon.vue?vue&type=script&lang=js"
import style0 from "./message-status-icon.vue?vue&type=style&index=0&id=97210bde&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97210bde",
  null
  
)

export default component.exports